// PatientDetails.jsx - Main Component
import React, { useEffect, useState } from 'react';
import { Button, Tabs } from 'antd';
import { 
  ArrowLeftOutlined, 
  TableOutlined, 
  ScheduleOutlined, 
  HistoryOutlined,
  DollarOutlined 
} from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { usePatientData, useReportHistory, useSchedules } from '../../../hooks/usePatientData';
import ReportTab from '../../PatientDetails/ReportTabs';
import ScheduleTab from '../../PatientDetails/ScheduelTab';
import ReportHistoryTab from '../../PatientDetails/REportHistoryTab';
import InvoiceTab from '../../PatientDetails/InvoiceTab';
import PatientHeader from '../../PatientDetails/PatientHeader';
import PatientInfoCard from '../../PatientDetails/PatientInfoCard';
import PatientQuestionsCard from '../../PatientDetails/QuestionCard';
import InvoiceModal from '../BookingsScreen/InvoiceModal';

const PatientDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [patient, setPatient] = useState(location.state?.patient);
  
  const [invoiceModalVisible, setInvoiceModalVisible] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);

  const { answers, loading: answersLoading } = usePatientData(patient?.id);
  const [editing ,setEditing]=useState(false);
  const { 
    schedules, 
    loading: schedulesLoading, 
    createSchedule, 
    updateSchedule, 
    deleteSchedule,
    refreshSchedules 
  } = useSchedules(patient?.accountId);
  const { 
    reportHistory, 
    pagination: historyPagination, 
    loading: historyLoading,
    loadReportHistory 
  } = useReportHistory(patient?.id);

  const [change, setChange] = useState(false);

  const handleEditInvoice = (invoice) => {
    setEditing(true);
    console.log('Edit invoice:', invoice);
    
    const bookingForModal = {
      id: invoice.bookingId,
      invoiceId: invoice.id,
      patientName: invoice.userName || patient?.firstName + ' ' + patient?.lastName,
      clinicId:invoice.clinicId,
      bookingCode:invoice.id
    };
    
    setSelectedBooking(bookingForModal);
    setInvoiceModalVisible(true);
  };

  // Handler for invoice modal success
  const handleInvoiceSuccess = (wasEdit) => {
    setInvoiceModalVisible(false);
    setSelectedBooking(null);
    
    // Refresh the invoice data
    queryClient.invalidateQueries(['userAccount']);
    queryClient.invalidateQueries(['invoice']);
    
    // Trigger any necessary refreshes
    setChange(!change);
  };

  // Handler for closing invoice modal
  const handleInvoiceCancel = () => {
    setInvoiceModalVisible(false);
    setSelectedBooking(null);
  };

  const tabItems = [
    {
      key: '4',
      label: (
        <span>
          <DollarOutlined className='px-1'/>
          Invoices
        </span>
      ),
      children: (
        <InvoiceTab 
          patient={patient}
          onEditInvoice={handleEditInvoice}
        />
      ),
    },
    // {
    //   key: '1',
    //   label: (
    //     <span>
    //       <TableOutlined className='px-1' />
    //       Reports
    //     </span>
    //   ),
    //   children: (
    //     <ReportTab 
    //       patient={patient} 
    //       setPatient={setPatient} 
    //       queryClient={queryClient}  
    //       onRefreshSchedules={refreshSchedules} 
    //       setChange={setChange} 
    //       change={change}
    //     />
    //   ),
    // },
    // {
    //   key: '2',
    //   label: (
    //     <span>
    //       <ScheduleOutlined className='px-1'/>
    //       Schedules
    //     </span>
    //   ),
    //   children: (
    //     <ScheduleTab 
    //       patient={patient}
    //       schedules={schedules}
    //       loading={schedulesLoading}
    //       onCreate={createSchedule}
    //       onUpdate={updateSchedule}
    //       onDelete={deleteSchedule}
    //       onRefresh={refreshSchedules}
    //       change={change}
    //       setChange={setChange}
    //     />
    //   ),
    // },
    {
      key: '3',
      label: (
        <span>
          <HistoryOutlined className='px-1'/>
          AI Reports History
        </span>
      ),
      children: (
        <ReportHistoryTab 
          patient={patient}
          reportHistory={reportHistory}
          pagination={historyPagination}
          loading={historyLoading}
          onPageChange={loadReportHistory}
        />
      ),
    },
  ];
  
  if (!patient) {
    return <div className="p-8 text-red-500">No patient data provided.</div>;
  }

  return (
    <div className='max-w-7xl mx-auto mt-5'>
      <div
        className="p-2 md:p-6 mx-auto bg-white shadow-md rounded-md"
        style={{ boxShadow: '0 6px 14px rgba(41, 141, 159, 0.3)' }}
      >
        <PatientHeader patient={patient} />

        {/* <PatientInfoCard patient={patient} /> */}

        <PatientQuestionsCard 
          answers={answers} 
          loading={answersLoading} 
        />

        <div className="mt-6">
          <Tabs
            defaultActiveKey="4"
            items={tabItems}
            size="large"
            tabBarStyle={{
              marginBottom: '24px',
              borderBottom: '2px solid #f0f0f0'
            }}
          />
        </div>
      </div>

      {/* Invoice Modal */}
      <InvoiceModal
        visible={invoiceModalVisible}
        onCancel={handleInvoiceCancel}
        booking={selectedBooking}
        services={[]} // Pass services if you have them, or fetch inside modal
        servicesLoading={false}
        isMobile={window.innerWidth < 768}
        onSuccess={handleInvoiceSuccess}
        patient={patient}
        editing={editing}

      />
    </div>
  );
};

export default PatientDetails;